import {defineSlotRecipe} from '@chakra-ui/react3'

export const carouselRecipe = defineSlotRecipe({
    slots: [
        'moduleContainer',
        'headerContainer',
        'headingCopyContainer',
        'ctaContainer',
        'sliderContainer'
    ],
    base: {
        moduleContainer: {
            display: 'flex',
            flexDirection: 'column',
            align: 'start',
            px: {base: 'spacing-24', s: 'spacing-90'}
        },
        headerContainer: {
            justifyContent: 'space-between',
            flexDirection: {base: 'column', s: 'revert'},
            gap: {base: 'spacing-32', s: 'spacing-80'}
        },
        headingCopyContainer: {
            gap: 'spacing-16',
            flexDirection: 'column',
            flex: 1,
            textAlign: {base: 'left', s: 'center'},
            maxWidth: {s: '38.875rem'}
        },
        ctaContainer: {
            alignContent: 'flex-end'
        },
        sliderContainer: {
            paddingTop: {base: 'spacing-40', s: 'spacing-80'}
        }
    }
})
